import { useEffect, useState } from "react";
import { Gift, Crown, Users, Flame } from "lucide-react";
import { useSite } from "@/context/SiteContext";

function useLeft(until) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!until) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [until]);
  if (!until) return null;
  const ms = Math.max(0, new Date(until).getTime() - now);
  const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
  const p = (n) => String(n).padStart(2, "0");
  return ms ? `${d ? `${d} gün ` : ""}${p(h)}:${p(m)}:${p(s)}` : null;
}

export default function GiftShowcase({ dark = false, className = "" }) {
  const { config } = useSite();
  const s = config.gift_showcase;
  const week = s?.week;
  const left = useLeft(week?.until);
  const boxes = (config.gift_boxes || []).map((g, i) => ({ text: g.join(" + "), sup: config.gift_super?.[i], week: left && week?.index === i })).filter((b) => b.text);
  if (!s?.enabled || !boxes.length) return null;
  const card = dark ? "bg-[#1d1c1a] border-[#D6AD62]/20 text-[#F3EEE4]" : "bg-[#171715] border-[#171715] text-[#F3EEE4]";
  return (
    <div className={className} data-testid="gift-showcase">
      <p className={`font-display font-bold tracking-wide ${dark ? "text-sm text-[#D6AD62]" : "text-xl sm:text-2xl"}`} data-testid="gift-showcase-title">{s.title}</p>
      <div className={`grid grid-cols-2 ${dark ? "gap-2 mt-3" : "sm:grid-cols-3 lg:grid-cols-6 gap-3 mt-5"}`}>
        {boxes.map((b, i) => (
          <div key={i} data-testid={`gift-showcase-item-${i}`}
            className={`gift-card relative rounded-xl border flex items-center gap-2.5 ${dark ? "px-3 py-2.5" : "px-4 py-4 lg:flex-col lg:text-center lg:py-6"} ${b.sup ? "gift-super" : card} ${b.week ? "gift-week" : ""}`}
            style={{ animationDelay: `${i * 70}ms` }}>
            <span className={`shrink-0 rounded-lg flex items-center justify-center ${dark ? "w-7 h-7" : "w-9 h-9"} ${b.sup ? "bg-[#111110] text-[#F3D592]" : "bg-[#D6AD62]/15 text-[#D6AD62]"}`}>
              {b.sup ? <Crown size={dark ? 14 : 18} /> : <Gift size={dark ? 14 : 18} />}
            </span>
            <span className={`font-semibold uppercase leading-tight ${dark ? "text-[11px]" : "text-xs sm:text-sm"}`}>
              {b.sup && <span className="block text-[10px] tracking-[.14em] opacity-80">Super hədiyyə</span>}
              {b.text}
              {b.week && (
                <span className={`block normal-case font-semibold mt-1.5 ${dark ? "text-[10px]" : "text-[11px]"} ${b.sup ? "text-[#111110]" : "text-[#F3D592]"}`} data-testid="gift-week-timer">
                  <Flame size={11} className="inline -mt-0.5 mr-1" />Həftənin hədiyyəsi · {left}
                </span>
              )}
            </span>
          </div>
        ))}
      </div>
      {s.winners != null && (
        <p className={`flex items-center gap-2 mt-4 text-sm ${dark ? "text-[#cfc9bd] !text-xs" : "text-[#4a4842]"}`} data-testid="gift-winners">
          <Users size={dark ? 14 : 16} className="text-[#b58a3f]" />
          Artıq qazanıblar: <b className={dark ? "text-[#F3D592]" : "text-[#171715]"} data-testid="gift-winners-count">{s.winners} nəfər</b>
        </p>
      )}
    </div>
  );
}
